import { HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import moment from 'moment';

import { environment } from '../../environments/environment';

export const URLS_SKIP_TS_HEADER = [environment.goodsReceiptEndpoint];

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (URLS_SKIP_TS_HEADER.some((url) => req.url.includes(url))) {
            return next.handle(req);
        }

        // Keeps the original request params. as a new HttpParams
        let newParams = new HttpParams({ fromString: req.params.toString() });

        // Add any params (can also chain .append() but I was conditionally adding params)
        newParams = newParams.append('ts', moment().valueOf() + '');

        // Clone the request with params instead of setParams
        const requestClone = req.clone({
            params: newParams,
        });

        return next.handle(requestClone);
    }
}
